import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton,
  ModalBody, ModalFooter, Button, Box, Text, VStack, Divider, SimpleGrid
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';

interface HistoricoLicencia {
  HistoricoId: number;
  fechaCambio: string;
  accion: string;
  Ciudadano: string;
  ine: string;
  nombreEstablecimiento: string;
  giro: string;
  tipo: string;
  Estatus: string;
  Movimiento: string;
  direccionx: string;
  montoLicencia: string;
  montoResiduos: string;
  FolioLicencia: string;
}

interface ModalHistorialProps {
  isOpen: boolean;
  onClose: () => void;
  licenciaId: number;
}

const ModalHistorialLicencia: React.FC<ModalHistorialProps> = ({
  isOpen, onClose, licenciaId
}) => {
  const [historial, setHistorial] = useState<HistoricoLicencia[]>([]);

  useEffect(() => {
    if (isOpen && licenciaId) {
      fetch(`https://totolac-backend.togui.com.mx/api/licencias-comercio/${licenciaId}/historico`)
        .then(res => res.json())
        .then(data => setHistorial(data.reverse()))
        .catch(err => console.error('Error al cargar historial:', err));
    }
  }, [isOpen, licenciaId]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
          bgImage="url('/img/bg.webp')"
          bgSize="cover"
          bgPosition="center"
          bgRepeat="no-repeat"
          color="white"
          textShadow="2px 2px 4px rgba(0,0,0,0.7)"
          fontWeight="bold"
          position="relative"
        >
          Historial de Cambios
        </ModalHeader>
        <ModalCloseButton color="white" _hover={{ bg: 'rgba(255,255,255,0.2)' }} />
        <ModalBody>
          {historial.length === 0 ? (
            <Text>No hay historial disponible.</Text>
          ) : (
            <VStack spacing={6} align="stretch">
              {historial.map((item) => (
                <Box key={item.HistoricoId} p={4} borderWidth="1px" borderRadius="md">
                  <Text fontWeight="bold" fontSize="lg" color="blue.600">
                    {item.accion} - {new Date(item.fechaCambio).toLocaleString()}
                  </Text>
                  <Divider my={3} />
                  <SimpleGrid columns={[1, null, 3]} spacing={4}>
                    <Text><strong>Ciudadano:</strong> {item.Ciudadano}</Text>
                    <Text><strong>INE:</strong> {item.ine}</Text>
                    <Text><strong>Establecimiento:</strong> {item.nombreEstablecimiento}</Text>

                    <Text><strong>Folio:</strong> {item.FolioLicencia}</Text>
                    <Text><strong>Giro:</strong> {item.giro}</Text>
                    <Text><strong>Tipo:</strong> {item.tipo}</Text>

                    <Text><strong>Estatus:</strong> {item.Estatus}</Text>
                    <Text><strong>Movimiento:</strong> {item.Movimiento}</Text>
                    <Text><strong>Dirección:</strong> {item.direccionx}</Text>

                    <Text><strong>Monto:</strong> ${parseFloat(item.montoLicencia).toFixed(2)}</Text>
                    <Text><strong>Monto Residuos:</strong> ${parseFloat(item.montoResiduos).toFixed(2)}</Text>
                    <Text><strong>Total:</strong> ${(
                      parseFloat(item.montoLicencia || '0') + parseFloat(item.montoResiduos || '0')
                    ).toFixed(2)}</Text>
                  </SimpleGrid>
                </Box>
              ))}
            </VStack>
          )}
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose} variant="ghost">Cerrar</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ModalHistorialLicencia;
